<script lang="ts">
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import ActionBarCard from "@shared/svelte/Components/ActionBarCard.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";

  import type { ImageObj } from "@shared/types/Images";
  import type { ProductSample } from "@shared/types/QuickOrderList";

  let productLineImages: ImageObj[] = [];
  let listId: number = undefined;
  const { trackClick } = EventTracking;

  const productDetailStateParamsList = [
    "category",
    "subcategory",
    "type",
    "tagName",
    "distributors",
    "search",
  ];

  const firstProductLinesWithImages = (productSample: ProductSample[]) => {
    if (!productSample) return;

    for (const sample of productSample) {
      if (
        sample.product_line &&
        (sample.product_line.image_version || sample.product_line.cloudinary_image_url)
      ) {
        productLineImages.push(sample.product_line);
        if (productLineImages.length >= 6) break;
      }
    }
  };

  let loadingProducts = true;

  const loadRecentlyOrdered = async () => {
    const response = await HttpPromise({
      method: "PUT",
      url: "/api/retailer/quick_order_lists/recently_ordered_products_sample",
    });

    listId = response.list_id;
    firstProductLinesWithImages(response.products_sample);
    loadingProducts = false;
  };
  loadRecentlyOrdered();
</script>

<ActionBarCard
  titleText="Easily order again"
  icon="History"
  iconFill="#1B1B1B"
  actionText="Go to list"
  on:actionClick={() => {
    trackClick("action_bar_go_to_list_link");
  }}
  actionLink={`/lists/${listId}?sort=last_ordered_at&direction=DESC`}
>
  <div slot="body" class="fizz-inset-vertical-12">
    <div class="fizz-flex-row-4 fizz-flex-wrap" style="overflow: hidden; --gap: 1000px 16px;">
      {#if loadingProducts}
        {#each Array(6) as _}
          <Skeleton animate={true} height={90} width={45} ariaLabel="product-image-loading" />
        {/each}
      {:else}
        {#each productLineImages as productLine, i}
          <UIRouterLink
            stateName="layout.product_detail"
            params={{ productId: productLine.id, indexPosition: i }}
            stateParamsToAdd={productDetailStateParamsList}
            classes="nounderline-hover fizz-styles fizz-flex-no-shrink"
            useTrackClick={true}
            targetObjectType="product_card"
            id={`product_${productLine.id}_image_link`}
          >
            <div class="fizz-surface fizz-text-center">
              <ProductImage
                height={90}
                width={45}
                product={productLine}
                fizz={true}
                skeleton={true}
              />
            </div>
          </UIRouterLink>
        {/each}
      {/if}
    </div>
  </div>
</ActionBarCard>
